import { api } from "@/lib/api/client";

const BASE = "/api/nexus/demo";

export interface DemoStatus {
  exists: boolean;
  userId: number | null;
  clubId: number | null;
  eventCount: number;
  lastResetAt: string | null;
}

export interface DemoActionResult {
  ok: boolean;
  userId?: number;
  clubId?: number;
  eventIds?: number[];
  deletedEventIds?: number[];
  newEventIds?: number[];
  created?: boolean;
}

export interface DemoCredentials {
  email: string;
  password: string;
}

export const demoApi = {
  status: async (): Promise<DemoStatus> => {
    const { data } = await api.get<DemoStatus>(`${BASE}/status`);
    return data;
  },

  seed: async (): Promise<DemoActionResult> => {
    const { data } = await api.post<DemoActionResult>(`${BASE}/seed`);
    return data;
  },

  reset: async (): Promise<DemoActionResult> => {
    const { data } = await api.post<DemoActionResult>(`${BASE}/reset`);
    return data;
  },

  credentials: async (): Promise<DemoCredentials> => {
    const { data } = await api.get<DemoCredentials>(`${BASE}/credentials`);
    return data;
  },
};
